module.exports = __webpack_public_path__ + "static/Srinivasa-e-brochure-52432418c2021b6da941116d6f36b2ee.pdf";